<template>
  <v-app>
    <v-card class="bgs rounded-0 d-flex justify-center" flat width="100%" height="100%">
      <v-container>
        <h2 class="text-center mt-6 font24 mb-4">
          {{ $t("Taoify用户隐私政策") }}
        </h2>
        <p class="content mt-4">
          {{ $t("提示：您如需注册或使用 Taoify平台服务，应当完整阅读并严格遵守《Taoify用户隐私政策》，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本用户隐私政策约束。") }}
        </p>
        <p class="content">
          {{ $t("Taoify有权不定期更新、修改本用户隐私政策里的内容，有权在 Taoify 网站上发布更新和修改本用户隐私政策。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。") }}
        </p>
        <p class="content">
          {{ $t("本协议为《Taoify服务条款》补充文件，全套文件还包括《Taoify 用户使用协议》《Taoify消费协议》等，其中《Taoify 服务条款》为主协议。本协议约定内容如与《Taoify 服务条款》冲突，以《Taoify 服务条款》为准；除本协议明确约定内容以外，双方所有其他权利义务、规则约束均以《Taoify 服务条款》《Taoify 用户使用协议》《Taoify消费协议》等为准。") }}
        </p>
        <p class="content">
          {{ $t("您完成账户注册，即代表您已充分知晓并自愿接受Taoify平台所有协议、条款，包括本用户隐私政策、《Taoify 用户使用协议》《Taoify 服务条款》《Taoify消费协议》等。若您不认可Taoify平台所有协议、条款内容，请立即停止注册。") }}
        </p>
        <p class="content">
          {{ $t("本协议中所有术语定义，均与《Taoify 服务条款》保持统一，不再重复释义。") }}
        </p>

        <h3 class="titlee">{{ $t("一、适用范围") }}</h3>
        <ul>
          <li>{{ $t("1、本政策适用于所有注册、访问、使用 Taoify 独立站建站平台的用户（商店所有者、员工账号）；") }}</li>
          <li>{{ $t("2、本政策规范两类信息处理：2.1 用户自身注册资质、经营信息；2.2 用户店铺面向境外消费者收集的个人信息；") }}</li>
          <li>{{ $t("3、本政策不适用于其他第三方（如支付、物流、广告服务商），第三方隐私规则由其自身政策约束，与平台无关。") }}</li>
          <li>{{ $t("4、您完成账户注册，将被视为接受、同意、确认：您在自愿下同意向我们披露个人资料；您会遵守本隐私政策的全部条款和限制；您在我们的网站上作登记、资料会被收集；您同意日后我们对隐私政策的任何修改；您同意我们的分公司、附属公司、雇员，就您可能会感兴趣的产品和服务与您联络。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("二、个人信息的收集") }}</h3>
        <p class="content">
          {{ $t("1、收集用户（平台注册用户）信息") }}
        </p>
        <p class="content">
          {{ $t("1.1 在您注册我们的服务、获取使用我们的服务或者以其他方式向我们提供信息时，我们会收集您的个人信息。") }}
        </p>
        <p class="content">
          {{ $t("1.2 经您同意，我们会收集、管理和监控个人资料。为了向您提供我们的各项服务，您需要提供个人资料，包括但不限于：企业名称、地址、联系电话、邮箱、营业执照、经营资质等，用于账户核验、资质审核、账单通知、售后对接、履约担保。") }}
        </p>
        <p class="content">
          {{ $t("1.3 我们收集您访问 Taoify 上的网页的相关数据。我们还会收集有关您访问账号的方式和时间的相关数据，包括您使用的设备和浏览器，网络连接以及您的IP地址、设备型号、登录时间、操作记录等信息，用于账户安全风控、异常登录识别、平台功能优化。") }}
        </p>
        <p class="content">
          {{ $t("1.4 我们收集与支付相关信息，包括但不限于支付和处理订单、绑定信用卡等。") }}
        </p>
        <p class="content">
          {{ $t("2、收集用户店铺的终端消费者信息：Taoify 仅作为技术工具存储数据，收集访客姓名、邮箱、电话、收货地址、支付订单、物流信息，用于订单履约、发货售后、订单对账。") }}
        </p>
        <p class="content">
          {{ $t("3、Cookie及非身份信息收集") }}
        </p>
        <p class="content">
          {{ $t("3.1 我们将通过您的IP地址来收集您的部分非个人化信息，例如您的浏览器性质、操作系统种类、给您提供接入服务的ISP的域名等，以优化在您计算机屏幕上显示的页面。通过收集该信息，我们将进行客流量统计，从而改进网站的管理和服务。") }}
        </p>
        <p class="content">
          {{ $t("3.2 Cookies是一种技术，当您访问设有Cookies装置的本网站时，本网站之服务器会自动发送Cookies至您浏览器内，并储存到您的电脑硬盘内，此Cookies便负责记录日后您到访本网站的种种活动、个人资料、浏览习惯、消费习惯、信用记录。") }}
        </p>
        <p class="content">
          {{ $t("3.3 运用Cookies技术，本网站能够为您提供更加周到的个性化服务。本网站将会运用Cookies追访您的购物喜好，从而向您提供感兴趣的信息资料或储存密码，以便您造访本网站时不必每次重复输入密码。") }}
        </p>
        <p class="content">
          {{ $t("3.4 您可自行在浏览器中关闭、清除 Cookie，关闭后部分平台功能将无法正常使用。") }}
        </p>

        <h3 class="titlee">{{ $t("三、个人信息的用途") }}</h3>
        <p class="content">
          {{ $t("通常情况，本网站将采取合理的措施保护您的个人信息，使其避免未经授权的披露。在遵守相关法律的前提下，我们可能会与以下实体（可能包括境内和境外）分享使用您的个人信息。") }}
        </p>
        <ul>
          <li>{{ $t("1、供应商：包括但不限于为了满足您网站需求的供货商、软件商、结汇收款、仓储物流、活动展会服务、代理商等。这些供应商可能根据需要与您联系，以完成相关产品服务；") }}</li>
          <li>{{ $t("2、金融机构和第三方支付机构：当您预订订单、申请退款、购买保险时，我们会与金融机构或第三方支付机构共享特定的订单信息，当我们认为用于欺诈检测和预防目的实属必要时，我们将进一步和相关金融机构共享其他必要信息，如IP地址等；") }}</li>
          <li>{{ $t("3、业务第三方：我们可能与第三方为您提供产品或者服务，包括快递业务、通讯服务、客户服务、市场推广、广告投放等；") }}</li>
          <li>{{ $t("4、我们可能会将来自某项服务的个人信息与来自其他服务的信息结合起来，用于为了给您提供更加个性化的服务使用；") }}</li>
          <li>{{ $t("5、经您许可的其他用途。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("四、个人信息的管理") }}</h3>
        <ul>
          <li>{{ $t("1、客户信息使用限制：作为 Taoify 平台商家，未经您书面明确许可，Taoify 不会主动单独联系您的客户，亦不会利用您店铺客户信息开展营销推广。但是如果我们是从其他渠道获取到您客户的信息，比如客户自己提供给我们，Taoify 可能会联系或向这些客户营销。") }}</li>
          <li>{{ $t("2、信息安全防护措施：Taoify 将落实物理、电子、流程、多维度技术安全防护机制，对平台存储的个人信息采取加密存储、访问权限管控、操作日志留痕等保护手段，防范个人信息泄露、篡改、丢失、非法访问。在我们网站上所搜集的一切资料都由我们所拥有，Taoify 不会向无关第三方共享、出租、出售您及您客户的任何个人信息。") }}</li>
          <li>{{ $t("3、网络传输风险提示：互联网传输环境存在固有安全风险，Taoify无法承诺网络传输过程实现绝对无风险。对因未经授权而接触您个人资料所发生的事件平台一概不承担责任，对于产生或导致的任何损失或损害，平台也不负责赔偿。") }}</li>
          <li>{{ $t("4、用户自身安全保管义务：您需妥善保管账号、登录密码、员工账号权限、支付相关信息，不得向无关第三方泄露；在公用设备、他人设备登录平台后，务必及时退出登录。因您未妥善保管账号、随意下放员工数据权限、主动泄露信息引发的数据泄漏、财产损失、行政处罚、第三方索赔，全部责任由您自行承担，平台不承担任何责任。") }}</li>
          <li>{{ $t("5、您对个人信息的自主管理权利：您依法享有个人信息的访问、查阅、更正、补充、限制使用、申请删除等权利。您可在店铺后台「账户设置」中自主编辑更新账户联系邮箱、联系电话、绑定支付卡片等基础信息。您可联系平台客服并提交对应证明材料申请更新营业执照、经营资质、历史备案主体等后台无法直接修改的信息。您可申请平台对非法定留存类个人信息进行删除。若您申请删除业务信息、限制订单/支付/风控所需信息的使用，店铺建站、收款、订单履约、账单推送等基础服务无法正常使用，由此产生的经营损失由您自行承担。") }}</li>
          <li>{{ $t("6、配套规则指引：本条未约定的员工数据权限管控、服务注销后信息留存、信息泄露赔付、第三方数据责任等全部事宜，均按照《Taoify 服务条款》《Taoify 用户使用协议》《Taoify 消费协议》执行。") }}</li>
          <li>{{ $t("7、信息限制：7.1 平台面向跨境商家，不主动收集未成年人信息，若您店铺收集未成年人信息，由您自行承担合规责任。7.2 用户店铺面向境外消费者收集的境外个人信息，由用户自行满足当地数据出境合规要求，平台仅提供存储技术服务。") }}</li>
          <li>{{ $t("8、信息储存与留存：服务无论因何种原因终止，您须自行完整留存店铺经营全部资料（包括但不限于订单记录、商品资质、购销合同、品牌授权、物流凭证、客户交易台账、质检报告等）并自行备案存档，我方无义务代为保管、整理、备案任何资料。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("五、我们如何共享信息") }}</h3>
        <p class="content">
          {{ $t("Taoify 对您及您店铺消费者的全部个人信息承担严格保密义务，不会以营销为目的向任何第三方出售、出租、共享您的个人信息。仅在以下法定、约定情形下，可依规共享相关信息：") }}
        </p>
        <ul>
          <li>{{ $t("1、事先取得您明确、书面的同意或授权；") }}</li>
          <li>{{ $t("2、依据生效法律文书、监管部门法定调查要求，配合司法、行政机关依法调取；") }}</li>
          <li>{{ $t("3、向 Taoify 母公司、子公司、全资关联主体共享信息，关联方同样受本隐私政策约束，仅可用于平台配套经营服务，不得对外二次泄露；") }}</li>
          <li>{{ $t("4、向可信第三方服务商（支付、物流、风控、建站插件等）提供必要信息，服务商仅能按照 Taoify 指令处理数据，且需遵守同等保密、安全义务，超出服务范围不得使用、披露您的信息；") }}</li>
          <li>{{ $t("5、为保护 Taoify、平台其他用户、终端消费者的人身、财产、数据合法权益，确有必要披露相关信息；") }}</li>
          <li>{{ $t("6、发生平台合并、收购、业务转让等情形，承接主体将继续受本隐私政策约束，若数据处理规则发生重大变更，平台将提前公示告知您。") }}</li>
          <li>{{ $t("7、用户存在违反中华人民共和国法律法规、平台协议及平台规则的行为；") }}</li>
          <li>{{ $t("8、为保护 Taoify、其关联主体、平台其他用户及终端消费者的合法权益。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("六、争议解决") }}</h3>
        <p class="content">
          {{ $t("1、平台有关条款（包括但不限于本用户隐私政策等）可能会有除中文以外的其他版本。如果不同语言版本的用户隐私政策之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本用户隐私政策条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本用户隐私政策，予以明确排除。") }}
        </p>
        <p class="content">
          {{ $t("2、因本协议引起或与本协议有关的任何争议，双方应友好协商解决；协商不成的，任何一方均有权向Taoify 平台经营地有管辖权的人民法院提起诉讼。") }}
        </p>
        <p class="content">
          {{ $t("3、争议处理期间，除争议事项外，双方应继续履行本协议其他约定。") }}
        </p>
        <p class="content">
          {{ $t("4、本协议部分条款被废止、无效或不能执行，并不影响其他条款效力。") }}
        </p>

        <p class="content">
          {{ $t("本平台由香港星橋國際貿易有限公司（https://aitaoify.com）运营，联系邮箱：liutaotao@taocarts.com，微信号：zzsist666。本政策更新日期：2026年1月1日。") }}
        </p>
        <p class="content">
          © {{ year }} Taoify · 香港星橋國際貿易有限公司 · 版权所有
        </p>
      </v-container>
    </v-card>
  </v-app>
</template>

<script>
export default { data() { return { year: new Date().getFullYear() }; } };
</script>

<style lang="scss" scoped>
.titlee {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 25px;
  margin-top: 25px;
  margin-bottom: 10px;
}
.content {
  font-size: 16px;
  line-height: 30px;
  font-weight: 300;
  color: #6a6e79;
}
li {
  font-size: 16px;
  line-height: 30px;
  font-weight: 300;
  color: #6a6e79;
  margin-left: 20px;
  list-style: initial;
}
</style>
